import { render, staticRenderFns } from "./card-vital-surround.vue?vue&type=template&id=280d3f04&scoped=true&"
import script from "./card-vital-surround.vue?vue&type=script&lang=js&"
export * from "./card-vital-surround.vue?vue&type=script&lang=js&"
import style0 from "./card-vital-surround.vue?vue&type=style&index=0&id=280d3f04&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "280d3f04",
  null
  
)

export default component.exports